import Duck from 'extensible-duck';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import requestsManagerAxios from '../../lib/requestsManagerAxios';

export const jerseyWatchTheme = createMuiTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: blue,
  },
});

export default new Duck({
  namespace: 'public',
  store: 'organization',
  types: [
    'FINISH_HOMEPAGE_SETUP',
    'MODIFY_COLOR',
    'MODIFY_PAGE_IS_ACTIVE',
    'CREATE_EXAMPLE_ANNOUNCEMENT',
    'CREATE_EXAMPLE_ANNOUNCEMENT_PENDING',
    'CREATE_EXAMPLE_ANNOUNCEMENT_REJECTED',
    'CREATE_EXAMPLE_ANNOUNCEMENT_FULFILLED',
    'UPDATE_ORGANIZATION',
    'UPDATE_ORGANIZATION_PENDING',
    'UPDATE_ORGANIZATION_REJECTED',
    'UPDATE_ORGANIZATION_FULFILLED',
  ],
  initialState: Immutable.fromJS({
    $$navbarItems: [],
    $$organization: {},
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.FINISH_HOMEPAGE_SETUP:
        return $$state.setIn(
          ['$$organization', 'meta', 'homepage_setup_complete'],
          true
        );
      case types.MODIFY_COLOR:
        return $$state.setIn(['$$organization', 'primary_color'], payload.hex);
      case types.MODIFY_PAGE_IS_ACTIVE: {
        const navbarItems = $$state.get('$$navbarItems').toJS();
        navbarItems.forEach(navbarItem => {
          if (navbarItem.id === payload.pageId)
            navbarItem.isActive = payload.isActive;
          if (navbarItem.children) {
            navbarItem.children.forEach(childPage => {
              if (childPage.id === payload.pageId)
                childPage.isActive = payload.isActive;
            });
          }
        });
        return $$state.set('$$navbarItems', Immutable.fromJS(navbarItems));
      }
      case types.UPDATE_ORGANIZATION_FULFILLED:
        return $$state.set('$$organization', Immutable.fromJS(payload.data));
      case 'public/schedule/CREATE_SCHEDULE_FULFILLED':
      case 'public/schedule/DELETE_SCHEDULE_FULFILLED':
      case 'public/schedule/UPDATE_SCHEDULE_FULFILLED':
        return $$state.set(
          '$$navbarItems',
          Immutable.fromJS(payload.data.navbarItems)
        );
      default:
        return $$state;
    }
  },
  selectors: {
    canEditOrganization: ($$state, $$railsContextStore) => {
      const userRole = $$railsContextStore.getIn(['$$currentUser', 'role']);
      switch (userRole) {
        case 'admin':
          return true;
        case 'organizer': {
          const userOrganizationId = $$railsContextStore.getIn([
            '$$currentUser',
            'organization_id',
          ]);
          const organizationId = $$state.getIn(['$$organization', 'id']);
          return organizationId === userOrganizationId;
        }
        default:
          return false;
      }
    },
    primaryColor: $$state => $$state.getIn(['$$organization', 'primary_color']),
    organizationTheme: new Duck.Selector(selectors =>
      createSelector(selectors.primaryColor, primaryColor => {
        return createMuiTheme({
          typography: {
            fontFamily: "'Anton', sans-serif",
            button: {
              fontSize: 18,
              letterSpacing: '0.035rem',
            },
            h4: {
              textTransform: 'uppercase',
            },
            h5: {
              textTransform: 'uppercase',
              letterSpacing: '0.025rem',
            },
            h6: {
              textTransform: 'uppercase',
              letterSpacing: '0.015rem',
              lineHeight: 1.25,
            },
            caption: {
              fontSize: 16,
              // textTransform: "uppercase",
              color: '#636363',
              letterSpacing: '0.015rem',
            },
          },
          palette: {
            primary: { main: primaryColor },
            text: {
              primary: '#404040',
            },
          },
        });
      })
    ),
    isUserSignedIn: $$railsContextStore =>
      $$railsContextStore.get('$$currentUser') !== null,
  },
  creators: ({ types }) => ({
    createExampleAnnouncement: phone => ({
      type: types.CREATE_EXAMPLE_ANNOUNCEMENT,
      payload: requestsManagerAxios.post('/admin/announcements/example', {
        phone,
      }),
    }),
    forceHomepageSetupComplete: () => ({ type: types.FINISH_HOMEPAGE_SETUP }),
    modifyColor: (primary, hex) => ({
      type: types.MODIFY_COLOR,
      payload: { primary, hex },
    }),
    modifyPageIsActive: (pageId, isActive) => ({
      type: types.MODIFY_PAGE_IS_ACTIVE,
      payload: { pageId, isActive },
    }),
    updateOrganization: organization => ({
      type: types.UPDATE_ORGANIZATION,
      payload: requestsManagerAxios.patch('/admin/organization/update', {
        organization,
      }),
    }),
    updateOrganizationFile: (key, file, config) => {
      const data = new FormData();
      data.append(`organization[${key}]`, file);
      return {
        type: types.UPDATE_ORGANIZATION,
        payload: requestsManagerAxios.patch(
          '/admin/organization/update',
          data,
          config
        ),
      };
    },
  }),
});
